import * as React from "react";
import { lazyLoading } from "./lazy-loading";

export function lazilyLoadedComponent<T extends React.ComponentType<any>>(
    assetName: string,
    loader: () => Promise<{ default: T }>
): React.LazyExoticComponent<T> {
    return React.lazy(() => lazyLoading(assetName, true, loader));
}
